@if (url) {
  @if (isBase64) {
    <img
      class="user-avatar user-avatar--img"
      [style.width.rem]="size"
      [style.height.rem]="size"
      [src]="url | async"
      alt="Avatar">
  } @else {
    <div
      class="user-avatar"
      [style.width.px]="size"
      [style.height.px]="size"
      [cropImage]="url | async"
      [disabled]="!crop"
      [additionalOptions]="{width: size, height: size, func: 'bound' }">
    </div>
  }
} @else {
  <div
    class="user-avatar user-avatar--initials"
    [class.dark-text]="isColorLight"
    [style.width.rem]="size"
    [style.height.rem]="size"
    [style.fontSize.rem]="fontSize"
    [style.background]="color">
    <span>{{initials || '?'}}</span>
  </div>
}

